import styled from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'

export const MenuList = styled.ul`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: var(--header-height);
  margin: 0;
  padding: 0;
  text-align: center;
  list-style: none;
  color: white;
  pointer-events: none;
  transition: 0.3s height;
  z-index: 1000;

  ${mq.smallOnly} {
    display: none;
  }

  li {
    display: block;
    position: relative;
    padding: 0 0.8em;
    pointer-events: auto;

    &[data-current='true'] {
      font-weight: bold;
    }

    ${mq.medium} {
      padding: 0 1em;
    }
  }

  button {
    ${styleReset}
    cursor: pointer;
  }
`
